export default __webpack_public_path__ + "static/media/avatar.2158bd7d.jpg";